import { Grid, GridProps, styled } from "@mui/material";
import {
  IconAccessPointOff,
  IconError404,
  IconFaceIdError,
  IconGardenCart,
  IconHourglassEmpty,
  IconInfoCircle,
  IconSearch
} from "@tabler/icons-react";
interface MxEmptyIconProps extends GridProps {
  variant?:
    | "error"
    | "404"
    | "no-connection"
    | "work"
    | "info"
    | "search"
    | "time";
}

const MxEmptyIcon = (props: MxEmptyIconProps) => {
  const { variant } = props;

  return (
    <ContentIcon>
      {variant === "error" && <IconFaceIdError />}
      {variant === "404" && <IconError404 />}
      {variant === "no-connection" && <IconAccessPointOff />}
      {variant === "work" && <IconGardenCart />}
      {variant === "info" && <IconInfoCircle />}
      {variant === "search" && <IconSearch />}
      {variant === "time" && <IconHourglassEmpty />}
    </ContentIcon>
  );
};

export default MxEmptyIcon;

const ContentIcon = styled(Grid)(({ theme }) => ({
  svg: {
    width: "3rem",
    height: "3rem",
    color: theme.palette.primary.main
  }
}));
